import { render } from "./DepartureItem.vue?vue&type=template&id=ad69b6d6&scoped=true&lang=pug"
import script from "./DepartureItem.vue?vue&type=script&lang=ts"
export * from "./DepartureItem.vue?vue&type=script&lang=ts"

import "./DepartureItem.vue?vue&type=style&index=0&id=ad69b6d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ad69b6d6"

export default script